import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import LinkIcon from '@mui/icons-material/Link';
import { useTranslation } from 'react-i18next';
import StarIcon, { StarSlashedIcon } from '../../../assets/svg/StarIcon';
import { Edit, KeyboardArrowRight, Remove } from '@mui/icons-material';
import { UserMinimal } from '../../../model/UserModel';

interface ItemOptionsMenuProps {
  itemIdUnShared?: string;
  emails?: UserMinimal[];
  downloadFile?:() => void;
  sharedFile?:() => void;
  unshared?: (itemId: string, emails: UserMinimal[]) => void;
  copyFileLinkUrl?: () => void;
}

export default function ItemOptionsMenu(props: ItemOptionsMenuProps) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElSubMenu, setAnchorElSubMenu] = React.useState<null | HTMLElement>(null);
  const openSubMenu = Boolean(anchorElSubMenu);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickSubMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorElSubMenu(event.currentTarget);
  };
  const handleCloseSubMenu = () => {
    setAnchorElSubMenu(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls={open ? 'file-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="file-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 2,
          sx: {
            minWidth: 200,
            maxWidth: 300,
            borderRadius: 2,
            paddingRight: 0,
            "& .MuiMenuItem-root:disabled": {
              background: "#000"
            },
            "& .MuiMenuItem-root": {
              paddingRight: 0,

            }
          }
        }}
      >
        {props.downloadFile && <MenuItem onClick={()=>{props.downloadFile!();handleClose()}}>
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("ItemOptionsMenu.download")}</ListItemText>
        </MenuItem>}
        {props.sharedFile && <MenuItem onClick={props.sharedFile} disabled={props.sharedFile == null}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("ItemOptionsMenu.edit")}</ListItemText>
        </MenuItem>}
        {props.unshared && <MenuItem onClick={handleClickSubMenu} disabled={props.unshared == null}>
          <ListItemIcon>
            <ShareIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("ItemOptionsMenu.unshared")}</ListItemText>
            <KeyboardArrowRight fontSize="small" />
        </MenuItem>}
        {props.copyFileLinkUrl && <MenuItem onClick={()=>{props.copyFileLinkUrl!();handleClose()}}>
          <ListItemIcon>
            <LinkIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t("ItemOptionsMenu.copyLink")}</ListItemText>
        </MenuItem>}
        <Menu
            id="long-menu"
            MenuListProps={{
            'aria-labelledby': 'long-button',
            style: {
                paddingBottom: 0,
                paddingTop: 0
            }
            }}
            anchorEl={anchorElSubMenu}
            open={openSubMenu}
            onClose={handleCloseSubMenu}
            anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }}
        >
            {(props.unshared && props.itemIdUnShared && props.emails && props.emails?.length > 1) && 
              <MenuItem onClick={()=>{props.unshared!(props.itemIdUnShared!, props.emails!);handleClose();handleCloseSubMenu()}}>
              <ListItemText>{t("ItemOptionsMenu.all")}</ListItemText>  
            </MenuItem>}
            {
              (props.unshared && props.itemIdUnShared && props.emails && props.emails?.length > 0) && 
              props.emails.map(email =>(
                <MenuItem onClick={()=>{props.unshared!(props.itemIdUnShared!, [email]);handleClose();handleCloseSubMenu()}}>
                  <ListItemText>
                    <Typography variant="body2">
                        {email.name}{" "}
                        <Typography component="span" variant="body2" color="text.secondary">
                            ({email.email})
                        </Typography>
                    </Typography>
                  </ListItemText>  
                </MenuItem>
              ))
            }
        </Menu>
      </Menu>
    </>
  );
}